import { render, staticRenderFns } from "./PublicationPreview.vue?vue&type=template&id=cf663d2e&scoped=true&"
import script from "./PublicationPreview.vue?vue&type=script&lang=js&"
export * from "./PublicationPreview.vue?vue&type=script&lang=js&"
import style0 from "./PublicationPreview.vue?vue&type=style&index=0&id=cf663d2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf663d2e",
  null
  
)

export default component.exports